export const doesPhoneCountryMatchSearch = (
  countryName: string,
  countryCode: string,
  search: string,
) =>
  !search.length ||
  countryName.toLowerCase().includes(search.toLowerCase()) ||
  countryCode.toLowerCase().includes(search.toLowerCase());
